import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':accountId'}/resendEmailInvite`;

export const ROUTE: RouteDefinition = `${baseRoute}/:accountId/resendEmailInvite`;

export const URL = (accountId: number): RouteDefinition => `${baseRoute}/${accountId}/resendEmailInvite`;
